import { assets } from '@yola/ws-sdk';

const copyExtensionAsset = async (iconSrc) => {
  const source = await assets.helpers.copyFromCdn(iconSrc);
  assets.operations.makePublishable(source);
  return source;
};

export default copyExtensionAsset;
